module.exports = __webpack_public_path__ + "static/starter-practice-ef6cf33c5c8968cd469b9d70cfa61aa5.png";